<div fxLayout="column" fxLayoutAlign="flex-start center" class="no-card mat-elevation-z3 p-12">
    <mat-icon class="mb-12 font-size-32 secondary-text">feedback</mat-icon>
    <ng-container [ngSwitch]="panel">
        <span 
            *ngSwitchCase="panelNames.notificationPanel" 
            class="secondary-text">
            {{'PANELS.NO-DATA.NOTIFICATIONS' | translate}}
        </span>
        <span 
            *ngSwitchCase="panelNames.reportPanel" 
            class="secondary-text">
            {{'PANELS.NO-DATA.REPORTS' | translate}}
        </span>
    </ng-container>
    
</div>